export const IMAGE_STATUS_CHOICES = [
  { id: 0, name: 'Not downloaded' },
  { id: 1, name: 'Downloaded' },
  { id: 2, name: 'In Progress' },
  { id: 9, name: 'Failed' },
];
